import {
  GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2,
  MeQuery_me_Member_merchants_Merchant_addresses_Address,
  ProductBySlugQuery_productBySlug_Product,
} from "@/Apollo/schema";
import { PRODUCT_DELIVERY_OPTIONS_MAP } from "@/features/product-delivery-options/static/product-delivery-options.static";

export type ProductDeliveryOptionItemProps = {
  product: ProductBySlugQuery_productBySlug_Product;
  option: GetProductShippingDetailsQuery_getProductShippingDetailsV2_ProductShippingDetailsV2_shippingOptions_ProductShippingOptionV2;
  loading?: boolean;
  defaultAddress?: MeQuery_me_Member_merchants_Merchant_addresses_Address;
};

export const ProductDeliveryOptionItem = (
  props: ProductDeliveryOptionItemProps
) => {
  const { option } = props;

  const Component =
    PRODUCT_DELIVERY_OPTIONS_MAP[
      `${option.shippingMethod}-${option.shippingProvider ?? "NONE"}`
    ];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
};
